import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { connect } from 'react-redux';
import Bio from '../bio/bio';
import Work from '../work/work';
import Contact from '../contact/contact';

class Panel extends Component {

  changePanelContent = () => {
    if(this.props.panelContent === 'Bio') return <Bio />
    else if(this.props.panelContent === 'Work') return <Work />
    else if(this.props.panelContent === 'Contact') return <Contact />
    else return 
  }

  render() {
    return (
      <div className={`col-md-5 offset-md-1 ${css(styles.panelBody)}`}>
        {this.changePanelContent()}
      </div>
    )
  }
}

const styles = StyleSheet.create({
  panelBody: {
    paddingBottom: '5vh',
    position: 'absolute',
    //border: 'solid black 1px',
    maxHeight: '93vh',
    //background: 'rgba(176, 175, 195, 0.10)',
    //opacity: '0.5',
    top: '10vh',
    zIndex: 5,
    overflow: 'scroll',
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 767px)': {
      position: 'static',
      paddingTop: '1vh',
      paddingRight: '5vw',
      paddingLeft: '5vw' 
    },
    '@media (min-width: 768px)': {
      position: 'absolute'
    } 
  }
})

const mapStateToProps = state => {
  return {
    panelContent: state.panelContent
  }
}

const mapDispatchToProps = dispatch => {
  return {
    OnPanelChanger: (val) => dispatch({type: 'CHANGE_PANEL', payload: val}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Panel);



// WEBPACK FOOTER //
// ./src/components/panel/panel.js